
import { Dispatch } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { UserDetailsActions } from "../actions/table_actions";
import { licensedata, catalogModule } from "../typing/types";
import { myfetchThunk } from "../../../app/myfetch";
import {masteruri} from "../../../config";
import { loginActions } from "../../Login/actions/LoginAction";
import { renewedToken } from "../../Login/typing/renewed_token_logic";
import { message, Modal } from "antd";


interface testdataResponsePayloadInterface{
    data:{
    license:licensedata[],
    }
}

interface userUpdateResponsePayloadInterface{
    save:string,
    /** Set when one's own password changed (anima_core#24). */
    token?:string
}



export const requestDataFromAPI =(uuid:string) => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{       
        dispatch(myfetchThunk(
            true,
            masteruri+"/License/"+uuid.toString(),
            {},
            "GET",
            (payload:testdataResponsePayloadInterface) => {
                console.log(payload)
                dispatch(
                    UserDetailsActions.resetData(
                         {
                             data : payload.data.license[0],
                         }
                     )
                 );
            },
            ()=>{}
        ) as any)
    }
}




export const requestClientToogle =(uuid:string, useruuid:string, action:string) => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{
        console.log("SEND");
        dispatch(myfetchThunk(
            true,
            masteruri+"/Users/Mandant/"+useruuid+"/"+uuid+"/"+action,
            {},
            "PUT",
            (payload:userUpdateResponsePayloadInterface) => {
                console.log(payload)               
                message.success(payload.save);
            },
            (payload:any) => {
                console.log("ERROR")
                console.log(payload)
                message.error(payload.save);
                
            },
        ) as any)
    }
}

export const requestUserNotCLientListFromAPI =(uuid:string) => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{
        console.log("SEND");
        // dispatch(myfetchThunk(
        //     true,
        //     masteruri+"/Users/Mandant/"+uuid+"/"+uuid+"/getnot",
        //     {},
        //     "PUT",
        //     (payload:licensedata) => {
        //         console.log(payload)
        //         if (payload.data.length > 0)
        //         {
        //         dispatch(
        //             UserDetailsActions.resetnotmandData(
        //                  {
        //                      data : payload.data,
        //                  }
        //              )
        //          );
        //         }
        //         else
        //         {
        //             dispatch(
        //                 UserDetailsActions.resetnotmandData(
        //                      {
        //                          data : [] as mandantendetails[],
        //                      }
        //                  )
        //              );
        //         }
                
        //     },
        //     (payload:any) => {
        //         console.log("ERROR")
        //         console.log(payload)
        //         message.error(payload.save);
                
        //     },
        //) as any)
    }
}

export const requestUserCLientListFromAPI =(uuid:string) => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{
        console.log("SEND");
        // console.log(masteruri+"/Users/Mandant/"+uuid+"/"+uuid+"/get");
        // dispatch(myfetchThunk(
        //     true,
        //     masteruri+"/Users/Mandant/"+uuid+"/"+uuid+"/get",
        //     {},
        //     "PUT",
        //     (payload:userMandantenResponsePayloadInterface) => {
        //         console.log(payload)
        //         if (payload.data.length > 0)
        //         {
        //         dispatch(
        //             UserDetailsActions.resetincmandData(
        //                  {
        //                      data : payload.data,
        //                  }
        //              )
        //          );
        //                 }
        //                 else
        //         {
        //             dispatch(
        //                 UserDetailsActions.resetincmandData(
        //                      {
        //                          data : [] as mandantendetails[],
        //                      }
        //                  )
        //              );
        //         }
                
        //     },
        //     (payload:any) => {
        //         console.log("ERROR")
        //         console.log(payload)
        //         message.error(payload.save);
                
        //     },
        // ) as any)
    }
}

export const requestUserUpdateFromAPI =(data:any, uuid:string) => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{
        console.log("SEND");
        console.log(data);
        console.log(masteruri+"/Users/"+uuid);
        dispatch(myfetchThunk(
            true,
            masteruri+"/Users/"+uuid,
            {data},
            "PUT",
            (payload:userUpdateResponsePayloadInterface) => {
                console.log(payload.save)
                // One's own password changed: every session of the account
                // ended, this one goes on with the renewed token
                // (anima_core#24) - before the next request.
                const token = renewedToken(payload);
                if (token !== null) {
                    dispatch(loginActions.renewToken({ token }));
                }
                message.success(payload.save);
            },
            (payload:any) => {
                console.log("ERROR")
                console.log(payload)
                message.error(payload.save);
                
            },
        ) as any)
    }
}



interface enrollmentCodeResponsePayloadInterface{
    code:string,
    expires:string,
    licence:string
}

/**
 * Issues a one-time enrollment code for this licence (#32) and shows it once.
 * The hub keeps only its hash; closing the dialog is the last chance to read it.
 */
export const requestEnrollmentCode =(uuid:string) => {
    return (
        dispatch:Dispatch<any>,
        getState:() => RootState
    )=>{
        dispatch(myfetchThunk(
            true,
            masteruri+"/Enrollment/code/"+uuid,
            {},
            "POST",
            (payload:enrollmentCodeResponsePayloadInterface) => {
                Modal.info({
                    title: "Enrollment code",
                    width: 560,
                    content: (
                        "Code: " + payload.code
                        + "  -  valid once, until " + new Date(payload.expires).toLocaleString()
                        + ". Hand it to the spoke operator (not by mail); they install with"
                        + " installiere.sh --enrollment-code <code>. It is shown only now."
                    ),
                });
            },
            (payload:any) => {
                message.error(payload?.message ?? "No enrollment code issued.");
            },
        ) as any)
    }
}


/**
 * Stores the number of targets the licence covers (admin only). The spoke takes
 * the new count over with its next licence check: the hub refuses its old token
 * and the spoke fetches a freshly signed one.
 */
export const requestTargetsUpdateFromAPI =(uuid:string, count:number) => {
    return (
        dispatch:Dispatch<any>,
        getState:() => RootState
    )=>{
        dispatch(myfetchThunk(
            true,
            masteruri+"/License/"+uuid+"/targets",
            {numberOfTargets: count},
            "PUT",
            (payload:{numberOfTargets:number}) => {
                message.success("Number of targets: " + payload.numberOfTargets
                    + " - the spoke takes it over with its next licence check.");
                dispatch(requestDataFromAPI(uuid) as any);
            },
            (payload:any) => {
                message.error(payload?.message ?? "Number of targets not saved.");
            },
        ) as any)
    }
}

/**
 * Moves the licence to another tier (free, business, enterprise). Its own call
 * like the tolerance; the hub moves the branch along ("free" <-> "release"),
 * because the spoke applies its free limits by the branch. Takes effect with
 * the spoke's next licence check.
 */
export const requestTierUpdateFromAPI =(uuid:string, tier:string) => {
    return (
        dispatch:Dispatch<any>,
        getState:() => RootState
    )=>{
        dispatch(myfetchThunk(
            true,
            masteruri+"/License/"+uuid+"/tier",
            {tier: tier},
            "PUT",
            (payload:{tier:string, branch:string, modules:string[]}) => {
                message.success("Tier: " + payload.tier + " (branch " + payload.branch + ") - "
                    + (payload.modules.length ? payload.modules.join(", ") : "no paid features")
                    + ". The spoke takes it over with its next licence check.");
                dispatch(requestDataFromAPI(uuid) as any);
            },
            (payload:any) => {
                message.error(payload?.message ?? "Tier not saved.");
            },
        ) as any)
    }
}

/** The hub's module catalog for the checklist in the licence details. */
export const requestModuleCatalogFromAPI =() => {
    return (
        dispatch:Dispatch<any>,
        getState:() => RootState
    )=>{
        dispatch(myfetchThunk(
            true,
            masteruri+"/Modules",
            {},
            "GET",
            (payload:{data:{user:catalogModule[]}}) => {
                dispatch(UserDetailsActions.SetModuleCatalog({modules: payload?.data?.user ?? []}));
            },
            () => {
                message.error("Module list not loaded.");
            },
        ) as any)
    }
}

/**
 * Stores the modules ticked on the licence - the complete list, what is
 * missing is withdrawn (PUT api/License/{id}/module). The tier's features
 * apply anyway. Takes effect with the spoke's next licence check.
 */
export const requestModulesUpdateFromAPI =(uuid:string, names:string[]) => {
    return (
        dispatch:Dispatch<any>,
        getState:() => RootState
    )=>{
        dispatch(myfetchThunk(
            true,
            masteruri+"/License/"+uuid+"/module",
            {module: names},
            "PUT",
            (payload:string[]) => {
                message.success("Extra modules: " + (payload && payload.length ? payload.join(", ") : "none")
                    + " - the spoke takes them over with its next licence check.");
                dispatch(requestDataFromAPI(uuid) as any);
            },
            (payload:any) => {
                message.error(payload?.message ?? "Modules not saved.");
            },
        ) as any)
    }
}

interface targetToleranceResponsePayloadInterface{
    targetTolerancePercent:number | null,
    effectivePercent:number
}

/**
 * Stores the licence's target tolerance (null = hub default). Its own call, not
 * part of the licence update: PUT api/License/{id} writes the whole entity back.
 * Takes effect with the spoke's next activation.
 */
export const requestToleranceUpdateFromAPI =(uuid:string, percent:number | null) => {
    return (
        dispatch:Dispatch<any>,
        getState:() => RootState
    )=>{
        dispatch(myfetchThunk(
            true,
            masteruri+"/License/"+uuid+"/targettolerance",
            {targetTolerancePercent: percent},
            "PUT",
            (payload:targetToleranceResponsePayloadInterface) => {
                message.success("Target tolerance: " + payload.effectivePercent + " %"
                    + (payload.targetTolerancePercent === null ? " (hub default)" : ""));
            },
            (payload:any) => {
                message.error(payload?.message ?? "Target tolerance not saved.");
            },
        ) as any)
    }
}
